export const formatString = (value?: number, days: boolean = false) => {
  if (value === 0 && days === false) {
    return 'None';
  } else if (value === 1) {
    return '1 year';
  } else {
    return `${value} years`;
  }
};

export const formatPriceToNumber = (value: string = '') => Number(value.replace(/[^0-9.]/g, ''));

export const formatCurrency = (value: number | undefined) => {
  if (value === undefined) return '';
  if (value % 1 === 0) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  } else
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(value);
};

export const formatWindHailDeductible = (deductible?: WindHailDeductible) =>
  deductible && `${deductible.percentage}% subject to ${formatCurrency(deductible.min)} min`;
